import Endpoint from "../Endpoint";
import { toFormData } from "../utils";

class Exercises extends Endpoint {
    buildUrl({ param }) {
        return ['exercises', param];
    }

    create(attributes, config = {}) {
        const formData = toFormData(attributes);

        return super.create(formData, {
            ...config,
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    }

    update(attributes, config = {}) {
        const formData = toFormData(attributes);

        return super.update(formData, {
            ...config,
            method: 'POST',
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    }
}

export default new Exercises;